module.exports = __webpack_public_path__ + "img/cash-counter-sm.827d17d3.png";